"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserDetails = UserDetails;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _link = _interopRequireDefault(require("@ux/link"));
var _reactMintl = require("@godaddy/react-mintl");
var _enums = require("./enums");
var _rewardsPoints = _interopRequireDefault(require("./rewards-points"));
var _vip = _interopRequireDefault(require("./vip"));
function UserDetails(props) {
  if (!props.loggedIn) {
    return null;
  }
  let details = null;
  const {
    vip
  } = props;
  if (props.preset === 'internal-header') {
    details = /*#__PURE__*/_react.default.createElement("div", {
      className: "account-name"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.username
    }), " : ", props.username);
  } else if (props.privateLabelType !== 3) {
    details = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "shopper-id"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.shopperid
    }), ": ", props.shopperId), /*#__PURE__*/_react.default.createElement("div", {
      className: "shopper-pin"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.pinLabel
    }), ' ', /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      urlArgs: props.urlArgs
    }, props.urls.viewPin, {
      "data-eid": props.eids.viewPin,
      target: "_blank"
    }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.viewPin
    }))));
  }
  return /*#__PURE__*/_react.default.createElement("div", null, details, props.proshopper && !props.pcx && /*#__PURE__*/_react.default.createElement(_rewardsPoints.default, {
    rewardPoints: props.rewardPoints
  }), vip && /*#__PURE__*/_react.default.createElement(_vip.default, {
    details: vip
  }));
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */
UserDetails.propTypes = {
  eids: _propTypes.default.object,
  loggedIn: _propTypes.default.bool,
  name: _propTypes.default.string,
  preset: _propTypes.default.string,
  privateLabelType: _propTypes.default.number,
  proshopper: _propTypes.default.bool,
  rewardPoints: _propTypes.default.number,
  shopperId: _propTypes.default.string,
  urls: _propTypes.default.object.isRequired,
  urlArgs: _propTypes.default.object,
  username: _propTypes.default.string,
  vip: _propTypes.default.object,
  pcx: _propTypes.default.bool
};
var _default = exports.default = UserDetails;